import { Configuration } from './Configuration'
import { ConstraintUtils } from '../constraint-utils'

export class ConfigurationUtils {
  public static update(source: Configuration, target: Configuration): void {
    ConstraintUtils.update(source?.spec, target?.spec)
    ConstraintUtils.updateConf(source?.conf, target?.conf)
  }
}
